<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <!-- If using vue-router -->
      <!-- <router-view></router-view> -->
      <v-card>
        <v-row dense class="pl-4 pr-4 pt-4 ">
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              label="Propinsi"
              clearable
              dense
              outlined
              v-model="selectedPropinsi"
              :items="items_propinsi"
              item-text="nama"
              @change="changePropinsi"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              label="Kabupaten/Kota"
              clearable
              dense
              outlined
              v-model="selectedKabupaten"
              :items="items_kabupaten"
              item-text="nama"
              @click="getListKabupaten"
              @change="changeKabupaten"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4"> </v-col>
        </v-row>
        <v-card-title>
          Pengurus Wilayah
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari Nama"
            single-line
            hide-details
            v-on:keyup.enter="getDataFromApi"
          ></v-text-field>
          <v-spacer></v-spacer>

          <router-link
            v-if="getRoleId == 1"
            to="/pengurus-wilayah-add"
            style="text-decoration: none; color: inherit;"
          >
            <v-btn color="blue" dark class="mb-2">
              Tambah
            </v-btn>
          </router-link>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Apa anda akan menghapus data ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Tidak</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Ya</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon medium class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon v-if="getRoleId == 1" medium @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import PengurusPusatService from "../services/PengurusPusatService";
import CommonService from "../services/CommonService";
import NakesService from "../services/NakesService";
import store from "../store/index";

export default {
  data: () => ({
    selectedPropinsi: "",
    selectedKabupaten: "",
    items_propinsi: [],
    items_kabupaten: [],
    breadcrumbs: [
      {
        text: "Data Pengurus",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Nama", value: "user_nama", sortable: false },
      { text: "Bidang", value: "bidang_nama", sortable: false },
      { text: "Jabatan", value: "jabatan_nama", sortable: false },
      { text: "Propinsi", value: "propinsi_nama", sortable: false },
      { text: "Kabupaten/Kota", value: "kabupaten_nama", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 5,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,
  }),
  watch: {
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getListPropinsi();
    this.getListKabupaten();
    this.getDataFromApi();
  },
  methods: {
    async getListPropinsi() {
      NakesService.propinsiList()
        .then((res) => {
          this.items_propinsi = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async changePropinsi() {
      this.selectedKabupaten = null;
      this.getDataFromApi();
    },

    async changeKabupaten() {
      this.getDataFromApi();
    },

    async getListKabupaten() {
      NakesService.kabupatenList(this.selectedPropinsi.id)
        .then((res) => {
          this.items_kabupaten = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      var propinsiId = null;
      var kabupatenId = null;

      if (this.selectedPropinsi) {
        propinsiId = this.selectedPropinsi.id;
      }

      if (this.selectedKabupaten) {
        kabupatenId = this.selectedKabupaten.id;
      }

      PengurusPusatService.pengurusWilayahList(
        page,
        itemsPerPage,
        this.search,
        propinsiId,
        kabupatenId
      )
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.$router.push("/pengurus-wilayah-edit/" + item.id).catch((err) => {
        console.log(err);
      });
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      PengurusPusatService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus pengurus wilayah berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showSuccessToast(
            "Hapus pengurus wilayah gagal. Coba lagi"
          );
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },

  computed: {
    getRoleId() {
      return store.getters.getUser.role_id;
    },
  },
};
</script>
